require('./bootstrap');
require('./custom');
require('@grubersjoe/slide-menu');

import AOS from 'aos';
import 'aos/dist/aos.css';

